import type { SuggestedAction } from './ChatWidget.types';

interface QuickActionsProps {
  actions: SuggestedAction[];
  onActionClick: (message: string) => void;
}

export function QuickActions({ actions, onActionClick }: QuickActionsProps) {
  if (actions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 px-4 py-3" data-testid="quick-actions">
      {actions.map((action) => (
        <button
          key={action.message}
          type="button"
          onClick={() => onActionClick(action.message)}
          className="rounded-full border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-100 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-300 dark:hover:bg-blue-900/40"
          data-testid="quick-action-chip"
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}
